var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round"},React.createElement("g",{"id":"minus","transform":"translate(1.000000, 0.000000)","stroke":"#2B271F","strokeWidth":"0.833333333"},React.createElement("line",{"x1":"6.04849504e-13","y1":"0.416666667","x2":"11.6666667","y2":"0.416666667"}))));
}

Minus.defaultProps = {"viewBox":"0 0 14 1","version":"1.1"};

module.exports = Minus;

Minus.default = Minus;
